export const PartnerTenant = {
  Breeder: 'Breeder',
  Vet: 'Vet',
  Influencer: 'Influencer',
  OtherPartnerBusiness: 'Other Business',
  Affiliate: 'Affiliate',
  Research: 'Research',
  Rescue: 'Rescue',
  BehaviouristTrainer: 'Behaviourist and Trainer',
} as const
export type PartnerTenant = typeof PartnerTenant[keyof typeof PartnerTenant]

export const PartnerTier = {
  Gold: 'gold',
  Silver: 'silver',
  Bronze: 'bronze',
  Unmanaged: 'unmanaged',
} as const
export type PartnerTier = typeof PartnerTier[keyof typeof PartnerTier]
